import ClientSearchContainer from './ClientSearchContainer'

function ClientSearchScreen(): JSX.Element {
    return <ClientSearchContainer />
}

export default ClientSearchScreen
